// mui
import { Snackbar, Alert } from '@mui/material';

// client-shared
import { storage } from '@goldblack/client-storage';

function ErrorPopup(props) {
    const internal = storage.transience.getValue('internal');

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        storage.transience.setState('internal.error', '');
    };

    return (
        <Snackbar
            open={internal.error !== ''}
            autoHideDuration={3000}
            onClose={handleClose}
            //slotProps={{ transition: { onEnter: Grow } }}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
            <Alert severity='error' variant='filled' sx={{ width: '100%', whiteSpace: 'pre-line' }}>
                {internal.error}
            </Alert>
        </Snackbar>
    );
}

function InfoPopup(props) {
    const internal = storage.transience.getValue('internal');

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        storage.transience.setState('internal.info', '');
    };

    return (
        <Snackbar
            open={internal.info !== ''}
            autoHideDuration={3000}
            onClose={handleClose}
            //slotProps={{ transition: { onEnter: Grow } }}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
            <Alert severity='info' variant='filled' sx={{ width: '100%' }}>
                {internal.info}
            </Alert>
        </Snackbar>
    );
}

function WarningPopup(props) {
    const internal = storage.transience.getValue('internal');

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        storage.transience.setState('internal.warning', '');
    };

    return (
        <Snackbar
            open={internal.warning !== ''}
            autoHideDuration={6000}
            onClose={handleClose}
            //slotProps={{ transition: { onEnter: Grow } }}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
            <Alert severity='warning' variant='filled' sx={{ width: '100%' }}>
                {internal.warning}
            </Alert>
        </Snackbar>
    );
}

function SuccessPopup(props) {
    const internal = storage.transience.getValue('internal');

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        storage.transience.setState('internal.success', '');
    };

    return (
        <Snackbar
            open={internal.success !== ''}
            autoHideDuration={3000}
            onClose={handleClose}
            //slotProps={{ transition: { onEnter: Grow } }}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
            <Alert severity='success' variant='filled' sx={{ width: '100%' }}>
                {internal.success}
            </Alert>
        </Snackbar>
    );
}

export { ErrorPopup, InfoPopup, WarningPopup, SuccessPopup };
